import React from 'react';
import PurchaseTableModal from '../Tables/PurchaseTableModal';
import PurchaseSummaryCard from '../purchases/common/PurchaseSummaryCard';
import { PurchaseSummary } from '../../types/purchases/BasePurchase';
import SvgIcon from '../SvgIcon/SvgIcon';

interface PendingPurchaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  purchases: PurchaseSummary[];
  onContinue: (purchase: PurchaseSummary) => void;
  onCancel?: (purchase: PurchaseSummary) => void;
}

const PendingPurchaseModal: React.FC<PendingPurchaseModalProps> = ({
  isOpen,
  onClose,
  purchases,
  onContinue,
  onCancel,
}) => {
  return (
    <PurchaseTableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Compras Pendientes"
      maxWidth="max-w-3xl"
    >
      <div className="max-h-[500px] overflow-y-auto p-4 sm:p-6">
        {purchases.length === 0 ? (
          <div className="text-gray-500 dark:text-gray-400 flex flex-col items-center gap-3 py-10 text-center text-sm">
            <SvgIcon name="document" width={32} height={32} className="opacity-40" />
            No hay compras pendientes.
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {purchases.map((item) => (
              <PurchaseSummaryCard
                key={item.id}
                purchase={item}
                actions={
                  <>
                    <button
                      className="flex items-center justify-center gap-2 rounded bg-primary px-3 py-2 text-sm font-medium text-white hover:bg-opacity-90"
                      onClick={() => onContinue(item)}
                    >
                      <SvgIcon name="continue" width={16} height={16} />
                      Continuar
                    </button>
                    {onCancel && (
                      <button
                        className="flex items-center justify-center gap-2 rounded border border-danger/40 px-3 py-2 text-sm font-medium text-danger transition hover:bg-danger/10"
                        onClick={() => onCancel(item)}
                      >
                        Cancelar
                      </button>
                    )}
                  </>
                }
              />
            ))}
          </div>
        )}
      </div>
    </PurchaseTableModal>
  );
};

export default PendingPurchaseModal;
